import React from 'react';
// import useNebula from 'hooks/useNebula';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import GroupedBar from '../Charts/GroupedBar';
import TranslationTxt from '../../survey2022/TranslationTxt/TranslationTxt';

import useStyles from './styles';

// import AppContext from '../AppContext';

const GroupedBarSection = ({
  header,
  text,
}) => {
  const classes = useStyles();

  return (
    <div className="section" style={{ marginBottom: 50, marginTop: 50 }}>
      <Typography variant="h3" className={classes.header}>
        <TranslationTxt measure={header} />
      </Typography>
      <Typography variant="body1" className={classes.text}>
        <TranslationTxt measure={text} />
      </Typography>
      <GroupedBar />
    </div>
  );
};

GroupedBarSection.propTypes = {
  header: PropTypes.string,
  text: PropTypes.string,
};

GroupedBarSection.defaultProps = {
  header: '',
  text: '',
};

export default GroupedBarSection;
